import { useMemo } from "react";
import { CATALOG_VISIBILITY_SLUGS } from "../../config/generated/catalog-visibility";
import { useOpenIdProviderData } from "../hooks/useAuth";
import { isPlcSuperuser } from "../utils/auth";

const buildHidingCss = (slugs: readonly string[]): string => {
  if (slugs.length === 0) return "";
  const selectors = slugs.flatMap((slug) => [
    `a[href$="#${slug}"]`,
    `div:has(> [id="${slug}"])`,
  ]);
  return `${selectors.join(",\n")} {\n  display: none !important;\n}`;
};

// Dev-only escape hatch
const forceSuperuserInDev =
  import.meta.env.DEV === true &&
  ["1", "true"].includes(
    String(import.meta.env.ZUDOKU_PUBLIC_FORCE_SUPERUSER ?? "").toLowerCase()
  );

export function CatalogVisibilityGate() {
  const providerData = useOpenIdProviderData();
  const hasSuperuserToken =
    providerData != null && isPlcSuperuser(providerData.accessToken);
  const isSuperuser = forceSuperuserInDev || hasSuperuserToken;

  const css = useMemo(() => {
    const superuserSlugs = CATALOG_VISIBILITY_SLUGS.superuser ?? [];
    const restrictedSlugs = isSuperuser ? [] : superuserSlugs;
    return buildHidingCss(restrictedSlugs);
  }, [isSuperuser]);

  if (!css) return null;

  return <style data-catalog-visibility>{css}</style>;
}
